import { render, staticRenderFns } from "./OptimaSettingsCategoryView.vue?vue&type=template&id=7ea1686a&scoped=true&"
import script from "./OptimaSettingsCategoryView.vue?vue&type=script&lang=js&"
export * from "./OptimaSettingsCategoryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea1686a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDataTable,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ea1686a')) {
      api.createRecord('7ea1686a', component.options)
    } else {
      api.reload('7ea1686a', component.options)
    }
    module.hot.accept("./OptimaSettingsCategoryView.vue?vue&type=template&id=7ea1686a&scoped=true&", function () {
      api.rerender('7ea1686a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/optima/OptimaSettingsCategoryView.vue"
export default component.exports